import Mock from "mockjs";
Mock.setup({
  // 延迟时间200毫秒
  timeout: 200,
});



// 嘉宾字幕列表
Mock.mock(
  "/homeapi/Guestagenda/getGuestsSearch?event_id=69",
  "get",
  {
    code: 1,
    msg: "获取成功",
    time: "1668910690",
    data: {
      "A": [
        {
          "id": 90,
          "name":'阿涛',
          "image_url":''
        },        {
          "id": 91,
          "name":'阿涛2',
          "image_url":''
        },        {
          "id": 92,
          "name":'阿涛3',
          "image_url":''
        },        {
          "id": 93,
          "name":'阿涛4',
          "image_url":''
        },        {
          "id": 94,
          "name":'阿涛5',
          "image_url":''
        }
      ],
      "C": [
        {
          "id": 20,
          "name":'灿灿1',
          "image_url":''
        },        {
          "id": 21,
          "name":'灿灿2',
          "image_url":''
        },        {
          "id": 22,
          "name":'灿灿3',
          "image_url":''
        },        {
          "id": 23,
          "name":'灿灿4',
          "image_url":''
        },        {
          "id": 24,
          "name":'灿灿5',
          "image_url":''
        }
      ],
      "Z": [
        {
          "id": 30,
          "name":'张三1',
          "image_url":''
        },        {
          "id": 31,
          "name":'张三2',
          "image_url":''
        },        {
          "id": 33,
          "name":'张三3',
          "image_url":''
        },        {
          "id": 33,
          "name":'张三4',
          "image_url":''
        },        {
          "id": 34,
          "name":'张三5',
          "image_url":''
        }
      ],
      "B": [
        {
          "id": 80,
          "name":'冰冰1',
          "image_url":''
        },        {
          "id": 81,
          "name":'冰冰2',
          "image_url":''
        },        {
          "id": 83,
          "name":'冰冰3',
          "image_url":''
        },        {
          "id": 83,
          "name":'冰冰4',
          "image_url":''
        },        {
          "id": 84,
          "name":'冰冰5',
          "image_url":''
        }
      ]
    }
  }
);

